import React from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { DashboardLayout } from '../layouts/DashboardLayout';
import { QuotesListPage } from '../pages/dashboard/QuotesListPage';
import { QuoteDetailPage } from '../pages/dashboard/QuoteDetailPage';

export const dashboardRoutes = (
  <Route element={<ProtectedRoute />}>
    <Route element={<DashboardLayout />}>
      <Route path="/dashboard" element={<QuotesListPage />} />
      <Route path="/dashboard/quotes/:id" element={<QuoteDetailPage />} />
    </Route>
  </Route>
);